document.addEventListener('reelfyGallery', function (event) {

    const { galleryData, galleryElement } = event.detail;

    const images = galleryElement.querySelectorAll(".reelfy_card_product__image img");

    images.forEach(img => {

        const srcImg = img.src.replace(/width=\d+/, "width=200");

        img.setAttribute("src", srcImg);

    });

});

document.addEventListener('reelfyFetchProduct', function (event) {

    const { productAjax, product } = event.detail;

    const img = productAjax.querySelector("img");

    img.setAttribute('src', product.featured_image + '&width=200');

});